function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { InputField } from "../../../../../Components/Forms";
import { Translate } from "../../../../../../I18N";



export const LabelField = ({
  register,
  errors,
  template,
  propertyToEdit





}) => {var _errors$label, _errors$label2;return (/*#__PURE__*/
    React.createElement(InputField, _extends({
      id: "property-label",
      label: /*#__PURE__*/
      _jsx("div", { className: "flex items-center gap-1" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Label"), /*#__PURE__*/
      _jsx("span", {}, void 0, "*")
      ),

      placeholder: "Text",
      hasErrors: !!errors.label || !!errors.duplicateLabel,
      disabled: (propertyToEdit === null || propertyToEdit === void 0 ? void 0 : propertyToEdit.isCommonProperty) && propertyToEdit.type === 'date',
      errorMessage:
      ((_errors$label = errors.label) === null || _errors$label === void 0 ? void 0 : _errors$label.type) === 'required' && /*#__PURE__*/_jsx(Translate, {}, void 0, "This field is required") ||
      ((_errors$label2 = errors.label) === null || _errors$label2 === void 0 ? void 0 : _errors$label2.type) === 'duplicateLabel' && /*#__PURE__*/
      _jsx(Translate, {}, void 0, "This label already exists in this template")


      // eslint-disable-next-line react/jsx-props-no-spreading
    }, register('label', {
      validate: {
        required: (value) => Boolean(value) || 'This field is required',
        duplicateLabel: (value) => {var _template$properties;
          const duplicateProperty = (_template$properties = template.properties) === null || _template$properties === void 0 ? void 0 : _template$properties.find(
            (p) => {var _p$label;return (
                ((_p$label = p.label) === null || _p$label === void 0 ? void 0 : _p$label.toLowerCase().trim()) === value.toLowerCase().trim() && (
                !propertyToEdit || p._id !== propertyToEdit._id));}
          );
          if (duplicateProperty) {
            return 'This label already exists in this template';
          }
          return true;
        }
      }
    }))
    ));};